// Production stub — zero mock code. Vite aliases this to
// components/mock/DevAuthButton when VITE_USE_MOCK_AUTH=true.
export interface DevAuthButtonProps {
    label: string;
    loadingLabel: string;
    isLoading: boolean;
    onClick: () => void;
}

export default function DevAuthButton(_props: DevAuthButtonProps) {
    return null;
}
